import { createFileRoute } from "@tanstack/react-router";
import WhatCanTmsTherapyTreatPage from "@/pages/articles/WhatCanTmsTherapyTreatPage";
export const Route = createFileRoute("/what-can-tms-therapy-treat")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "What Can TMS Therapy Treat? Conditions & Applications | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "What conditions can TMS therapy treat? Learn about FDA-cleared and off-label uses for TMS and SAINT TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content:
            "What Can TMS Therapy Treat? Conditions & Applications | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "What conditions can TMS therapy treat? Learn about FDA-cleared and off-label uses for TMS and SAINT TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/what-can-tms-therapy-treat",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-can-tms-therapy-treat",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatCanTmsTherapyTreatPage />;
}
